import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, EventEmitter, Inject, Input, Optional, PLATFORM_ID, Renderer2, NgZone } from '@angular/core';
import { timer } from 'rxjs';
import { loadLazyJsFile, loadLazyCssFile, checkIsTouchMobile } from '../util';
import { mCustomScrollbarAssetsDefaultConfig, M_CUSTOM_SCROLLBAR_ASSETS } from './m-custom-scrollbar.module';

@Directive({
  selector: '[tmMCustomScrollbar]',
  exportAs: 'mCustomScrollbar',
})
export class MCustomScrollbarDirective implements AfterViewInit {
  /** mCustomScrollbar 插件初始化完成後觸發 */
  static pulginInit = new EventEmitter<void>();
  /** 全域的 mCustomScrollbar 插件初始化完成 */
  static isPluginInit = false;
  /** 全域的 mCustomScrollbar 插件在正初始化中 */
  static isPluginIniting = false;
  /** 載入插件的方法 */
  static loadPlugin(renderer: Renderer2, parentEl: Element, assetsConfig: { scripts: string[]; styles: string[]; }) {
    MCustomScrollbarDirective.isPluginIniting = true;
    checkIfDepLoad(() => {
      assetsConfig.scripts.forEach(sc => {
        const sca = sc.split('/');
        const scName = sca[sca.length - 1];
        loadLazyJsFile(renderer, scName, sc);
      });
      checkPluginCanUse(() => {
        MCustomScrollbarDirective.isPluginInit = true;
        MCustomScrollbarDirective.isPluginIniting = false;
        MCustomScrollbarDirective.pulginInit.emit();
        MCustomScrollbarDirective.pulginInit.complete();
      });
    });

    assetsConfig.styles.forEach(st => {
      const sta = st.split('/');
      const stName = sta[sta.length - 1];
      loadLazyCssFile(renderer, parentEl, stName, st);
    });
  }
  /** 是否渲染端為瀏覽器 */ // tslint:disable-next-line: member-ordering
  protected isBrowser: boolean;
  /** 是否可以開始使用元件了 */ // tslint:disable-next-line: member-ordering
  canInit = false;
  /** mCustomScrollbar [config](http://manos.malihu.gr/jquery-custom-content-scroller/) */ // tslint:disable-next-line: member-ordering
  @Input('tmMCustomScrollbar') config: any = {};
  /** 在觸控螢幕裝置上不使用特效 */
  @Input() noTouchScreen = true;
  private isTouchScreen: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    @Optional() @Inject(M_CUSTOM_SCROLLBAR_ASSETS) private assets: { scripts: string[]; styles: string[]; },
    private el: ElementRef,
    private render: Renderer2,
    private zone: NgZone,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.isTouchScreen = checkIsTouchMobile();
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      if (this.noTouchScreen && this.isTouchScreen) {
        this.render.setStyle(this.el.nativeElement, 'overflow-y', 'auto');
      } else {
        if (!MCustomScrollbarDirective.isPluginInit && !MCustomScrollbarDirective.isPluginIniting) {
          if (isPluginLoaded()) {
            MCustomScrollbarDirective.isPluginInit = true;
          } else {
            MCustomScrollbarDirective.loadPlugin(this.render, this.el.nativeElement, this.assets || mCustomScrollbarAssetsDefaultConfig);
          }
        }
  
        if (!MCustomScrollbarDirective.isPluginInit) {
          MCustomScrollbarDirective.pulginInit.subscribe(() => {
            this.init();
            this.canInit = true;
          });
        } else {
          this.init();
          this.canInit = true;
        }
      }
    }
  }

  init() {
    this.zone.runOutsideAngular(() => {
      $(this.el.nativeElement).mCustomScrollbar(this.config);
    });
  }

  destroy() {
    $(this.el.nativeElement).mCustomScrollbar('destroy');
  }
}

function isPluginLoaded() {
  return jQuery.prototype.mCustomScrollbar;
}

const checkPluginCanUse = (cb: () => void) => {
  const cpTmSubc = timer(0, 150).subscribe(t => {
    if (isPluginLoaded()) {
      cpTmSubc.unsubscribe();
      cb();
    }
  });
};

function isDepLoadeed() {
  return 'undefined' !== typeof window['jQuery'];
}

function checkIfDepLoad(cb: () => void) {
  const cdTmSubc = timer(0, 300).subscribe(t => {
    if (isDepLoadeed()) {
      cdTmSubc.unsubscribe();
      cb();
    }
  });
}
